import cn from "classnames";
import Tooltip from "rc-tooltip";
import React, { Component } from "react";

export default class InlineBtn extends Component {
    handleClick = () => {
        const { param, action, disabled } = this.props;
        return action && !disabled ? action(param) : null;
    };

    render() {
        const { value, cname, disabled, tooltip } = this.props;
        const cName = cn({
            "inline-btn": true,
            "inline-btn--disabled": disabled,
            "inline-btn--without-icon": !cname,
            [`inline-btn--${cname}`]: !!cname,
        });

        const btn = (
            <div className={cName} onClick={this.handleClick}>
                {value}
            </div>
        );

        return tooltip ? (
            <Tooltip placement="right" overlay={tooltip}>
                {btn}
            </Tooltip>
        ) : (
            btn
        );
    }
}
